import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";
import HttpClient from "../utils/HttpClient";
import { useSelector } from "react-redux";
import toast from 'react-hot-toast';

const AddBusinessKeywordModal = ({ closemodal, services, ids, setServices, updateForm, setIsUpdate }) => {
  const { UserProfileID } = useSelector((state) => state.app);
  const [newKeyword, setNewKeyword] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [keywordOptions, setKeywordOptions] = useState([])
  const [showAddNewKeyword, setShowAddNewKeyword] = useState(false);

  const handleChange = (event, newValue) => {
    const newTotKeywords = services.length + selectedOptions.length + 1;
    if (newTotKeywords > 6) {
      toast.error("Cannot add more keywords — limit reached")
    } else {
      setSelectedOptions(newValue);
    }
  };

  const getBusinessKeywords = async () => {
    try {
      const res = await HttpClient.requestData("business-product-keywords", "GET");
      if (res?.status) {
        const filteredData = res.data.filter(
          (item) => !ids.includes(item._id)
        );
        setKeywordOptions(filteredData || [])
      }
    } catch (error) {
      console.error("Error fetching country states:", error);
    }
  };

  const createKeyword = async () => {
    if (!newKeyword.trim()) {
      toast.error("Keyword cannot be empty");
      return;
    }
    const dataToSend = {
      keyword: newKeyword.trim()
    }
    try {
      const response = await HttpClient.requestData(`keyword`, "POST", dataToSend);
      if (response.status) {
        toast.success("Keyword created successfully!");
        setNewKeyword("");
        setShowAddNewKeyword(false);
        getBusinessKeywords();
      } else {
        toast.error(response.message || "Failed to create keyword.");
      }
    } catch (error) {
      console.error("Error creating keyword:", error);
      toast.error("An unexpected error occurred.");
    }
  }

  useEffect(() => {
    getBusinessKeywords()
  }, [])

  const submit = () => {
    const flatSelectedOptions = selectedOptions.map((item) => item.keyword)
    const flatSelectedOptionsIds = selectedOptions.map((item) => item._id)
    const updatedKeywords = [...services, ...flatSelectedOptions];
    const updatedKeywordsIds = [...ids, ...flatSelectedOptionsIds];
    setServices(updatedKeywords);
    updateForm("businessProductkeywords", updatedKeywords);
    updateForm("businessProductkeywordsId", updatedKeywordsIds);
    setIsUpdate(true)
    closemodal(false);
  };

  return (
    <div className="edittamodalboixshadow">
      <div className="edittamodalboixsbg">
        {/* <div className="crossdivicon" onClick={() => closemodal(false)}>
          <i className="fa-solid fa-xmark" style={{ marginTop: "8px" }}></i>
        </div>
        <div className="edittappduudivnhhb">
          <h4 className="upldbannertrtxtpp">Add Keywords</h4>
        </div> */}
        <h5 className="mt-2 p-0 m-3">Add Keywords</h5>
        <div className="crossdivicon" onClick={() => closemodal()} style={{ cursor: "pointer" }}>
          <i className="fa-solid fa-xmark"></i>
        </div>
        <hr />
        <div className="abattstdovvstttschgg">
          <Autocomplete
            multiple
            options={keywordOptions}
            getOptionLabel={(option) => option.keyword}
            value={selectedOptions}
            onChange={handleChange}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  key={option.id}
                  label={option.keyword}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField {...params} label="Select keywords" placeholder="Type to search" />
            )}
          />
          {/* "Add More" Button */}
          {!showAddNewKeyword && (
            <div style={{ marginTop: '10px' }}>
              <button
                onClick={() => setShowAddNewKeyword(true)}
                className="svavtatvvbtnnm" // Reusing the button class for basic styling
                style={{ background: '#007bff', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer' }}
              >
                Add More
              </button>
            </div>
          )}

          {/* Add New Service Input and Save Button */}
          {showAddNewKeyword && (
            <div style={{ marginTop: '10px', display: 'flex', gap: '10px', alignItems: 'center' }}>
              <input
                type="text"
                value={newKeyword}
                onChange={(e) => setNewKeyword(e.target.value)}
                placeholder="Enter new service name"
                style={{ flexGrow: 1, padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
              />
              <button
                onClick={createKeyword}
                className="svavtatvvbtnnm"
                style={{ background: '#28a745', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer' }}
              >
                Save
              </button>
            </div>
          )}

          {selectedOptions?.length > 0 && (
            <div className="svavtatvvbtnnmpaggdijbtn">
              <button onClick={submit} className="svavtatvvbtnnm">
                Save
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddBusinessKeywordModal;
